
const spiralParamaters = (spiral, stepDist, sigDigs) => {

  if (spiral.spiType !== "clothoid") {
    console.error(`Unsupported Spiral Type: ${spiral.spiType}. Only clothoid spirals detected.`);
    return false;
  }

  const RL = Math.pow(parseFloat(spiral.constant), 2);
  let reverseCurve;
  let partial = false;

  if (spiral.radiusEnd === 'INF') {
    reverseCurve = true;
  } else if (spiral.radiusStart === 'INF'){
    reverseCurve = false;
  } else {
    reverseCurve = (spiral.radiusEnd > spiral.radiusStart);
    partial = true;
  }

  const cw = spiral.rot === "cw";
  let L = spiral.length;

  let delta;
  if (cw) {//cw
    if (reverseCurve){ // cw reverse curve
      delta = spiral.dirEnd;
    } else { // cw forward curve
      delta = -spiral.dirStart;
    }
  } else {// ccw
    if (reverseCurve) {// ccw reverse curve
      delta = -spiral.dirEnd;
    } else {// ccw forward curve
      delta = spiral.dirStart;
    }
  }

  let a = spiral.Start[0];
  let b = spiral.Start[1];
  let c = spiral.End[0];
  let d = spiral.End[1];

  let xStart;
  let yStart;

  let xEnd;
  let yEnd;

  let xCorr=0.0;
  let yCorr=0.0;
  let deltaCorr = 0.0;

  let segmentMin;
  let segmentMax;

  if (partial && !reverseCurve) { //partial forward curve
    let ls = RL / spiral.radiusStart;
    L += ls;
    segmentMin = parseInt((ls * sigDigs).toString());
    segmentMax = parseInt((L * sigDigs).toString());

    xCorr = ls - (Math.pow(ls, 5) / (40.0 * RL * RL)) +
      (Math.pow(ls, 9) / (3456.0 * Math.pow(RL, 4))) -
      (Math.pow(ls, 13) / (599040.0 * Math.pow(RL, 6)));
    yCorr = (Math.pow(ls, 3) / (6 * RL)) -
      (Math.pow(ls, 7) / (336.0 * Math.pow(RL, 3))) +
      (Math.pow(ls, 11) / (42240.0 * Math.pow(RL, 5))) -
      (Math.pow(ls, 15) / (9676800.0 * Math.pow(RL, 7)));
    deltaCorr = Math.pow(ls, 2) / (2 * RL);
  } else if (partial && reverseCurve){
    let le = RL / spiral.radiusEnd;
    let ls = RL / spiral.radiusStart;

    deltaCorr = Math.pow(le, 2) / (2 * RL);
    xCorr = le - (Math.pow(le, 5) / (40.0 * RL * RL)) +
      (Math.pow(le, 9) / (3456.0 * Math.pow(RL, 4))) -
      (Math.pow(le, 13) / (599040.0 * Math.pow(RL, 6)));
    yCorr = (Math.pow(le, 3) / (6 * RL)) -
      (Math.pow(le, 7) / (336.0 * Math.pow(RL, 3))) +
      (Math.pow(le, 11) / (42240.0 * Math.pow(RL, 5))) -
      (Math.pow(le, 15) / (9676800.0 * Math.pow(RL, 7)));

    segmentMin = parseInt((le * sigDigs).toString());
    segmentMax = parseInt((ls * sigDigs).toString());

  } else{
    segmentMin = 0;
    segmentMax = parseInt((L * sigDigs).toString());
  }

  let distMin = 1000000;
  let deltas = [
    delta, delta+deltaCorr, delta-deltaCorr,
    -1*(delta)-deltaCorr, -1*(delta)+deltaCorr, -delta];

  let endPointError = true;
  let chosenDelta = delta;

  deltas.forEach(deltaTrial => {
    let l = segmentMax / sigDigs;
    let x = l - (Math.pow(l, 5) / (40.0*RL*RL)) +
      (Math.pow(l,9) / (3456.0 * Math.pow(RL,4))) -
      (Math.pow(l,13) / (599040.0*Math.pow(RL,6)));

    let y = (Math.pow(l, 3) / (6*RL)) -
      (Math.pow(l,7) / (336.0*Math.pow(RL,3))) +
      (Math.pow(l, 11) / (42240.0*Math.pow(RL,5))) -
      (Math.pow(l, 15) / (9676800.0*Math.pow(RL, 7)));

    x -= xCorr;
    y -= yCorr;

    let xDiff = (x * Math.cos(deltaTrial) - y * Math.sin(deltaTrial));
    let yDiff = (x * Math.sin(deltaTrial) + y * Math.cos(deltaTrial));

    // console.log(`diffs x: ${xDiff} | y: ${yDiff}`);

    let xRotated;
    let yRotated;
    if (!reverseCurve) {//forward curve
      xRotated = a + xDiff;
      if (!cw) {//ccw forward
        yRotated = b - yDiff;
      } else {//cw forward
        yRotated = b + yDiff;
      }
      let dist = Math.sqrt(Math.pow(xRotated - c, 2)
        + Math.pow(yRotated - d, 2));
      if (dist < distMin) {
        distMin = dist;
        xEnd = xRotated;
        yEnd = yRotated;
        xStart = a;
        yStart = b;
        chosenDelta = deltaTrial;
      }
      if (dist <= Math.sqrt(2)*stepDist) {
        endPointError = false;
      }
    } else {//reverse curve
      xRotated = c - xDiff;
      if (!cw) {//ccw reverse
        yRotated = d - yDiff;
      } else {//cw reverse
        yRotated = d + yDiff;
      }

      let dist = Math.sqrt(Math.pow(xRotated - a, 2)
        + Math.pow(yRotated - b, 2));

      if (dist < distMin) {
        distMin = dist;
        xEnd = c;
        yEnd = d;
        xStart = xRotated;
        yStart = yRotated;
        chosenDelta = deltaTrial;
      }
      if (dist <= Math.sqrt(2)*stepDist) {
        endPointError = false;
      }
    }
  });
  if (endPointError) {
    console.error('Error in endpoint calculation');
    console.log(`Datum correct data: xDiff: ${a-c} | yDiff: ${b-d}`);
    console.log(`${xStart} | ${yStart} | at length ${segmentMin / sigDigs} | 0`);
    console.log(`${xEnd} | ${yEnd} | at length ${segmentMax / sigDigs} | ${spiral.length}`);
    console.log(`${xStart - a} | ${yStart - b} | at length ${segmentMin / sigDigs} | ${spiral.length}`);
    console.log(`${xEnd - c} | ${yEnd - d} | at length ${segmentMax / sigDigs} | ${spiral.length}`);
  }

  return {chosenDelta: chosenDelta, xStart: xStart, xEnd: xEnd,  yStart: yStart,
    yEnd: yEnd, xCorr: xCorr, yCorr:yCorr, reverseCurve: reverseCurve, partial: partial,
    segmentMin: segmentMin, segmentMax:segmentMax, RL:RL, cw:cw, a:a, b:b, c:c, d:d
  };
};

export const spiralIntersect = (spiral, point) => {
  const stepDist = 0.01;
  const sigDigs = 1000000;
  const spiralParams = spiralParamaters(spiral, stepDist, sigDigs);
  if (typeof spiralParams === "boolean") {
    return false;
  }
  let segmentMin = spiralParams.segmentMin;
  let segmentMax = spiralParams.segmentMax;

  // Now that the correct rotation and position corrections have been calculated
  // the entire spiral can be calculated, and the closest point to the clicked point can
  // be estimated.
  let spiralCoord=null;
  let distAlong=null;
  let distAcross = null;

  for (;segmentMin<=segmentMax;segmentMin+=stepDist*sigDigs) {
    if ((segmentMin+=stepDist*sigDigs) > segmentMax){
      segmentMin = segmentMax;
    }
    let l = segmentMin / sigDigs;

    let x = l - (Math.pow(l, 5) / (40.0*spiralParams.RL*spiralParams.RL)) +
      (Math.pow(l,9) / (3456.0 * Math.pow(spiralParams.RL,4))) -
      (Math.pow(l,13) / (599040.0*Math.pow(spiralParams.RL,6)));

    let y = (Math.pow(l, 3) / (6*spiralParams.RL)) -
      (Math.pow(l,7) / (336.0*Math.pow(spiralParams.RL,3))) +
      (Math.pow(l, 11) / (42240.0*Math.pow(spiralParams.RL,5))) -
      (Math.pow(l, 15) / (9676800.0*Math.pow(spiralParams.RL, 7)));

    x -= spiralParams.xCorr;
    y -= spiralParams.yCorr;

    let xDiff = (x * Math.cos(spiralParams.chosenDelta)
      - y * Math.sin(spiralParams.chosenDelta));
    let yDiff = (x * Math.sin(spiralParams.chosenDelta)
      + y * Math.cos(spiralParams.chosenDelta));
    let xAtLength, yAtLength, lengthLocal;
    if (spiralParams.partial) {
      lengthLocal = l - (segmentMin/sigDigs);
    } else {
      lengthLocal = l;
    }

    if (spiralParams.reverseCurve) {
      lengthLocal = spiral.length - lengthLocal;
    }

    if (!spiralParams.reverseCurve) {//forward curve
      xAtLength = spiralParams.a + xDiff;
      if (!spiralParams.cw) {//ccw forward
        yAtLength = spiralParams.b - yDiff;
      } else {//cw forward
        yAtLength = spiralParams.b + yDiff;
      }
    } else {//reverse curve
      xAtLength = spiralParams.c - xDiff;
      if (!spiralParams.cw) {//ccw reverse
        yAtLength = spiralParams.d - yDiff;
      } else {//cw reverse
        yAtLength = spiralParams.d + yDiff;
      }
    }

    const distAcrossNew = Math.sqrt(Math.pow(point[0] - xAtLength, 2)
      + Math.pow(point[1] - yAtLength, 2));
    // console.log(distAcrossNew)
    if (distAcross !== null) {
      const update = (distAcrossNew<distAcross);
      distAcross = update ? distAcrossNew : distAcross;
      distAlong = update ? lengthLocal : distAlong;
      spiralCoord = update ? [xAtLength, yAtLength] : spiralCoord;
    } else {
      distAcross = distAcrossNew;
      distAlong = lengthLocal;
      spiralCoord = [xAtLength, yAtLength];

      if (distAcrossNew < stepDist) {
        break;
      }
    }
  }

  const sideValue = ((spiralParams.a - spiralCoord[0]) *
    (point[1] - spiralCoord[1])) - (spiralParams.b -
    spiralCoord[1])*(point[0] - spiralCoord[0]);

  const sideOfLine = sideValue > 0 ? 'L':'R';

  // console.log(`across: ${distAcross} | along: ${distAlong} | side: ${sideOfLine}`);

  return {distAcross: distAcross, distAlong: distAlong,
    sideOfLine:sideOfLine, coordinates:spiralCoord};
};

export const lineDist = (geometry) => {
  const dist = Math.sqrt(Math.pow(geometry.Start[0] - geometry.End[0], 2) +
    Math.pow(geometry.Start[1] - geometry.End[1], 2));
  return dist;
};

export const curveDist = (geometry) => {
  const dist = lineDist(geometry);
  const calcAngle = Math.acos(1 - (dist * dist) /
      (2 * geometry.radius * geometry.radius));
  return geometry.radius * calcAngle;
};